import {DownOutlined, LoadingOutlined, UpOutlined} from "../_snowpack/pkg/@ant-design/icons.js";
import {AutoComplete, Button} from "../_snowpack/pkg/antd.js";
import React, {useEffect, useLayoutEffect, useMemo, useState} from "../_snowpack/pkg/react.js";
import {DEFAULT_ZOOM, GOOGLE_MAPS_KEY, INITIAL_INPUT_DATA} from "../constants.js";
import {mapStore} from "../util/mapStore.js";
import {MapMarker} from "./MapMarker.js";
import "./MapPicker.css";
import {MapContainer, Marker, TileLayer, useMapEvents} from "../_snowpack/pkg/react-leaflet.js";
import "../_snowpack/pkg/leaflet/dist/leaflet.css";
import * as ReactDOMServer from "../_snowpack/pkg/react-dom/server.js";
import L from "../_snowpack/pkg/leaflet.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import {GoogleProvider} from "../_snowpack/pkg/leaflet-geosearch.js";
import debounce from "../_snowpack/pkg/lodash/debounce.js";
import {IrradiationGauge} from "./IrradiationGauge.js";
export const MapPicker = ({value, onChange, mobile}) => {
  const {t} = useTranslation();
  const [mapState, setMapState] = useState(value);
  const [position, setPosition] = useState(value.location);
  const [zoom] = useState(DEFAULT_ZOOM);
  const [collapsed, setCollapsed] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setCollapsed(false), 1200);
    return () => clearTimeout(timer);
  }, []);
  const provider = new GoogleProvider({
    params: {
      key: GOOGLE_MAPS_KEY,
      region: "id"
    }
  });
  useLayoutEffect(() => {
    mapStore.subscribe((state) => {
      setMapState(state);
      setPosition(state.location);
      if (state.geoEnabled === false) {
        setEditMode(true);
      }
      if (onChange) {
        onChange(state);
      }
    });
  }, []);
  const updatePosition = async (location, enabled) => {
    mapStore.setLocation(location, enabled);
    console.log("mapStore.setLocation(location)", location);
    setPosition(location);
  };
  const locationNotFound = () => {
    console.log("no location");
    setCollapsed(false);
    setEditMode(true);
  };
  function LocationMarker() {
    const mapInstance = useMapEvents({
      click(e) {
        console.log("clickie");
        updatePosition(e.latlng, mapState.geoEnabled);
        console.log("fly");
      },
      locationfound(e) {
        updatePosition(e.latlng, mapState.geoEnabled);
        console.log("locationfound", e);
        console.log("flyt", e);
        console.log("flyto", position, mapInstance.getZoom());
      },
      locationerror(e) {
        if (!mobile) {
          locationNotFound();
        }
      }
    });
    useEffect(() => {
      if (position === INITIAL_INPUT_DATA.location.location) {
        if (mobile) {
          if (window && typeof window["postMessage"] === "function")
            window.postMessage("location");
        } else {
          const lok = mapInstance.locate();
          console.log("lok", lok);
        }
      }
    });
    useMemo(() => {
      if (mapInstance.getCenter() !== position || mapInstance.getZoom() !== zoom) {
        console.log("memo-update", mapInstance.getCenter(), position, mapInstance.getZoom(), zoom);
        mapInstance.setView(position, DEFAULT_ZOOM);
      }
    }, [position]);
    return position ? /* @__PURE__ */ React.createElement(Marker, {
      position,
      icon: L.divIcon({className: "custom-icon", html: ReactDOMServer.renderToString(/* @__PURE__ */ React.createElement(MapMarker, null))})
    }) : null;
  }
  const [options, setOptions] = useState([]);
  const previewOptions = useMemo(() => options.map((x) => {
    return {value: JSON.stringify(x.value), label: x.label};
  }), [options]);
  const findResults = async (s) => {
    const results = await provider.search({query: s});
    const res = results.map((x) => {
      const coords = {lat: x.y, lng: x.x};
      return {value: coords, label: `${x.label}`};
    });
    setOptions(res);
  };
  const [editMode, setEditMode] = useState(false);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: `map-picker ${collapsed ? "collapsed" : "expanded"}`
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ant-input map-picker-header"
  }, editMode && !collapsed ? /* @__PURE__ */ React.createElement(AutoComplete, {
    onSearch: debounce(findResults, 500),
    options: previewOptions,
    autoFocus: true,
    onBlur: () => setEditMode(false),
    onSelect: (x, y) => {
      console.log("x", x, y.label);
      const coords = JSON.parse(x);
      updatePosition(coords);
      setEditMode(false);
      setMapState((prev) => {
        return {location: prev.location, address: `${y.label}`, info: prev.info};
      });
    }
  }) : /* @__PURE__ */ React.createElement("div", {
    className: "map-picker-address",
    onClick: () => {
      if (collapsed) {
        setCollapsed(false);
        setEditMode(true);
      } else {
        setEditMode(true);
      }
    }
  }, mapState.address === "" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(LoadingOutlined, {
    style: {fontSize: 16},
    spin: true
  }), "  ") : /* @__PURE__ */ React.createElement(React.Fragment, null), mapState.address === "" ? mapState.info ? t("inputForm.chooseLocation") : t("inputForm.findingLocation") : mapState.address), /* @__PURE__ */ React.createElement(Button, {
    style: {color: "#bfbfbf"},
    icon: collapsed ? /* @__PURE__ */ React.createElement(DownOutlined, null) : /* @__PURE__ */ React.createElement(UpOutlined, null),
    type: "text",
    loading: false,
    size: "small",
    onClick: () => {
      setCollapsed(!collapsed);
    }
  })), /* @__PURE__ */ React.createElement("div", {
    className: "map-picker-view"
  }, /* @__PURE__ */ React.createElement(IrradiationGauge, {
    irradiation: mapState.info ? mapState.info.dni : 600,
    mobile
  }), /* @__PURE__ */ React.createElement(MapContainer, {
    center: [position.lat, position.lng],
    zoom,
    scrollWheelZoom: false,
    id: "map"
  }, /* @__PURE__ */ React.createElement(TileLayer, {
    url: "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
    subdomains: ["mt0", "mt1", "mt2", "mt3"]
  }), /* @__PURE__ */ React.createElement(LocationMarker, null)))));
};
